import keyEventListener from 'common/keyEventListener'
import HostInquirer from './HostInquirer'

class HostEventListener extends HostInquirer {
    constructor(context) {
        super(context)
        this.initiated = false
    }

    init = () => {
        if (!this.initiated) {
            this.initiated = true
            this.registerEventListener()
        }
    }

    registerEventListener = () => {
        const { context } = this
        keyEventListener({
            context,
            keys: [
                {
                    key: 'Escape',
                    eventName: 'keydown',
                    action: () => {
                        context.Pico.handleEscapeClicked()
                    },
                },
            ],
        })
    }
}

export default HostEventListener
